// truncate text to 100 characters (including ellipsis)
export const truncate = (text, maxLength = 97, suffix = '...', prefix = '')=>text.length > maxLength ? `${prefix}${text.substring(0, maxLength)}${suffix}` : text;

//# sourceMappingURL=text.js.map